import React, { FC } from 'react';
import Image from 'next/image';

export interface IMainSplashScreenProps {}

const MainSplashScreen: FC<IMainSplashScreenProps> = () => {
  return (
    <div className="z-[9999999999] flex items-center justify-center bg-[#fff] page-full">
      <Image
        alt="کارگزاری مفید، پیشرفت مداوم"
        height={76}
        src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/logo-col.svg"
        width={132}
        priority
      />
    </div>
  );
};

export default MainSplashScreen;
